import Accordion from "src/components/molecules/accordion/Accordion";
import Layout from "../../components/layout";
import styles from "./faq.module.scss";

const items = [
  {
    question: "Wat is de Garage mentality",
    answer:
      "De ultieme sportwagen creëren: dat ging niet vanzelf. Voor het ontstaan van de eerste Porsche was een ondernemende mentaliteit nodig. Een droom realiseren vraagt om veerkracht. Door niet op te geven werd in de garage vanuit een ruwe schets een iconisch sportwagenmerk geboren. Bij Porsche noemen we deze mentaliteit daarom de Garage Mentality. Die staat voor ondernemerschap, ambitie en innovatie.",
  },
  {
    question: "Wat is AI?",
    answer:
      "AI (artificial intelligence), of kunstmatige intelligentie, verwijst naar het vermogen van een computer of machine om de cognitieve functies van de menselijke geest, zoals leren en problemen oplossen, te repliceren. Dit kan taken omvatten zoals het begrijpen en interpreteren van gesproken of geschreven taal, het herkennen van beelden en patronen, en het nemen van beslissingen. Er zijn veel verschillende soorten AI, waaronder smalle AI, die is ontworpen om een specifieke taak uit te voeren, en algemene AI, die is ontworpen om elke intellectuele taak te kunnen uitvoeren die een mens kan uitvoeren.",
  },
  {
    question: "Hoe werkt de AI-tool",
    answer: `
GPT-3, of Generative Pre-trained Transformer 3, is een groot taalverwerkings-AI-model ontwikkeld door OpenAI. Het is ontworpen om mensachtige tekst te genereren op basis van een gegeven vraag. Om GPT-3 te gebruiken stel je een vraag en dan genereert het model tekst als antwoord op die vraag. De tekst die het model genereert is gebaseerd op de patronen en relaties die het heeft geleerd van de gegevens waarop het is getraind, waaronder een grote dataset van menselijke taal.

Om GPT-3 een vraag te stellen over "Garage Mentality", stel je het model een vraag in het thema van de Garage Mentality. Het model genereert vervolgens een antwoord op basis van de patronen en relaties die het heeft geleerd van de gegevens waarop het is getraind, waaronder een grote dataset van menselijke taal. Het specifieke antwoord dat het model genereert, hangt af van de input die het krijgt en de algoritmen en technieken die worden gebruikt om die input te verwerken.
    `,
  },
  {
    question: "Hoe verbetert AI de gebruikerservaring op deze site?",
    answer:
      "AI, met gebruik van GPT-3, zorgt ervoor dat wij passende antwoorden kunnen geven op jouw persoonlijke business vragen.",
  },
  {
    question: "Wordt mijn data bewaard?",
    answer:
      "De Garage Mentality AI-tool is niet ontworpen om gegevens over individuele gebruikers op te slaan, maar om antwoorden te verwerken en te genereren op basis van de ontvangen input (de vraag). Jouw gegevens worden dus nergens opgeslagen.",
  },
  {
    question: "Waarom worden sommige vragen door de AI-tool geblokkeerd?",
    answer:
      "Binnen de Garage Mentality-campagne voorziet de AI-tool jou op basis van de input van succesvolle ondernemers van adviezen en inspiratie. De garage is een plek voor innovatie en nieuwe ideeën. Onderwerpen die niet passen binnen die mentaliteit, worden daarom mogelijk geblokkeerd. Stel een vraag die past binnen de Garage Mentality om inspiratie op te doen. ",
  },
  {
    question: "Ik wil graag feedback geven op jullie AI-tool, hoe doe ik dat?",
    answer: (
      <>
        AI, of kunstmatige intelligentie, verwijst naar het vermogen van een
        computer of machine. AI is niet alwetend, wat betekent dat er soms
        onjuistheden kunnen optreden. Net zoals bij de mens. Mocht een antwoord
        op jouw vraag niet correct, ongepast of onvolledig zijn, dan ontvangen
        we graag jouw feedback. Je kunt jouw feedback insturen via{" "}
        <a href="mailto:marketing@porsche.nl">marketing@porsche.nl</a>.
      </>
    ),
  },
  {
    question: "Wat is Discovered?",
    answer: (
      <>
        Discovered is een online lifestylemagazine van Porsche. Discovered
        verkent de werelden van onder andere kunst, design, mode en reizen aan
        de hand van ondernemers die het op inspirerende wijze anders doen dan
        anderen.{" "}
        <a
          href="https://discovered.porsche.nl/"
          target="_blank"
          rel="noopener noreferrer"
        >
          Ontdek Discovered
        </a>
        .
      </>
    ),
  },
  {
    question: "De Porsche Taycan inspireert me. Waar vind ik meer informatie?",
    answer: (
      <>
        Inlezen start op de{" "}
        <a
          href="https://www.porsche.com/netherlands/nl/models/taycan/taycan-models/taycan/"
          target="_blank"
          rel="noopener noreferrer"
        >
          website van Porsche
        </a>
        . Voor een live kennismaking ben je welkom bij één van de Nederlandse
        Porsche Centra.
        <a
          href="https://www.porsche.com/netherlands/nl/dealersearch/"
          target="_blank"
          rel="noopener noreferrer"
        >
          Porsche Centra
        </a>
        .
      </>
    ),
  },
];

export default function FAQ() {
  return (
    <Layout className={styles.root}>
      <div className={styles.headingContainer}>
        <h1 className={styles.heading}>Veelgestelde vragen</h1>
      </div>
      <ul className={styles.itemList}>
        {items.map((item, index) => {
          return (
            <li className={styles.item} key={index}>
              <div>
                <Accordion
                  title={item.question}
                  initialIsOpen={false}
                  interactive
                  key="desktop"
                  iconUrl="/plus.svg"
                  secondaryIconUrl="/minus.svg"
                  iconAlt="plus"
                >
                  <p className={styles.paragraph}>{item.answer}</p>
                </Accordion>
              </div>
            </li>
          );
        })}
      </ul>
    </Layout>
  );
}
